import { PACK } from '../consts/packs';
import { getCurrentPack } from '.';

export const generateLink = (url: string, name: string) => {
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', name);
  document.body.appendChild(link);
  link.click();
};

export const getValueByPath = (obj: Record<string, any>, key: string): any => {
  const keys = key.split('.');
  let current = obj;
  for (let i = 0; i < keys.length; i++) {
    if (current == null) {
      return undefined;
    }
    current = current[keys[i]];
  }
  return current;
};

export const filteroutFilters = (filters: Record<string, any>, allowedFilters: string[]) => {
  const filterKeys = Object.keys(filters);
  return allowedFilters.reduce((res, filterKey) => {
    if (filterKeys.includes(filterKey)) res[filterKey] = filters[filterKey];
    return res;
  }, {} as Record<string, any>);
};

export const isPublicPack = (): boolean => {
  const pack = getCurrentPack();
  return pack === PACK.leConnect || pack === PACK.public;
};

export const isNumber = (value: any): value is number => typeof value === 'number';